import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TripTypeProp, getCMSTripTypes } from '../../models';
import { RadioButton } from '../../components/RadioButton';

export const TripTypeItemDesktop = ({ tripType, selected, onChange }) => {
    const { t } = useTranslation();

    return (
        <div className="odf-col odf-space-outer-right-m">
            <RadioButton
                checked={tripType === selected}
                id={`tripTypeSwitcher_${tripType}`}
                onChange={() => onChange(tripType)}
            >
                <span dangerouslySetInnerHTML={{ __html: `${t(getCMSTripTypes()[tripType])}` }} />
            </RadioButton>
        </div>
    );
};

TripTypeItemDesktop.propTypes = {
    tripType: TripTypeProp.isRequired,
    selected: TripTypeProp.isRequired,
    onChange: PropTypes.func.isRequired,
};
